/** The After tab (2.F deliverable 4): a link beside a session document's tabs, nowhere else. */
import { flagsFromMe, type SlotComponentProps, tid } from '@codex/contracts';
import { useDocMeta } from '../documents/use-doc-meta.js';
import { useGoTo } from '../shell/open-doc.js';
import { useShellSession } from '../shell/session.js';

export const afterHref = (sessionId: string) => `/after/${sessionId}`;

export function AfterTab({ docId }: SlotComponentProps) {
  const me = useShellSession();
  const enabled = me !== null && flagsFromMe(me).sessions === true;
  return enabled ? <AfterTabFor docId={docId} /> : null;
}

function AfterTabFor({ docId }: { readonly docId: string }) {
  const goTo = useGoTo();
  const meta = useDocMeta(docId);
  if (meta.data?.typeKey !== 'session') return null;
  const href = afterHref(docId);
  return (
    // The host supplies no tablist (DocSlotOutlet renders its entries bare), so the tab brings
    // its own: a tab with no tablist parent is an axe `aria-required-parent` violation.
    <span role="tablist" aria-label="Session views" className="cx-after-tabs">
      <a
        role="tab"
        aria-selected={false}
        className="cx-after-tab"
        href={href}
        onClick={(event) => goTo(href, event)}
        {...tid('after.page.tab')}
      >
        After
      </a>
    </span>
  );
}
